const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'lds_admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

export class AuthError extends Error {}

export const adminFetch = async (path, options = {}) => {
  const token = getAdminToken();
  const res = await fetch(`${BACKEND_URL}${path}`, {
    ...options,
    headers: { ...(options.headers || {}), Authorization: `Bearer ${token || ''}` }
  });
  if (res.status === 401) {
    clearAdminToken();
    throw new AuthError('Session expired');
  }
  return res;
};

export const adminLogin = async (password) => {
  const res = await fetch(`${BACKEND_URL}/api/auth/login`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Unable to sign in');
  setAdminToken(data.token);
};

export const checkAdminSession = async () => {
  if (!getAdminToken()) return false;
  try {
    const res = await adminFetch('/api/auth/me');
    return res.ok;
  } catch {
    return false;
  }
};
